/** @jsx jsx */
import { jsx, Flex, Box, Label, Input, Textarea, Button, Styled } from 'theme-ui'
import { useState } from 'react'
import querystring from 'query-string'

const clearForm = {
  first: '',
  last: '',
  email: '',
  phone: '',
  referralFirst: '',
  referralLast: '',
  referralEmail: '',
  referralPhone: '',
  comment: '',
}

const ReferralForm = () => {
  const [form, setForm] = useState({ ...clearForm })

  const [success, setSuccess] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    const data = {
      ...form,
      'form-name': 'referral'
    }
    const stringified = querystring.stringify(data);
    try {
      const response = await fetch(`/`, {
        method: 'POST',
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: stringified
      })
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      setForm({ ...clearForm })
      setSuccess(true)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Box
      as='form'
      name='referral'
      action='/'
      data-netlify='true'
      netlify-honeypot="required"
      onSubmit={handleSubmit}>
      <div sx={{ display: 'none' }}>
        <input name="required" />
        <input type="hidden" name="form-name" value="referral" />
      </div>
      <Flex
        sx={{
          mx: -4,
          mb: 3,
          flexWrap: 'wrap'
        }}>
        <Box
          sx={{
            px: 4,
            width: ['full', '1/2']
          }}>
          <Styled.h4
            sx={{
              color: 'gray.7',
              mb: 3
            }}>
            Your Details
          </Styled.h4>
          <Flex
            sx={{
              flexWrap: 'wrap',
              mx: -3
            }}>
            <Box
              sx={{
                width: ['full', '1/2'],
                px: 3
              }}>
              <Label
                sx={{ color: 'gray.6' }}
                htmlFor='first'>First Name</Label>
              <Input
                name='first'
                id='first'
                value={form.first}
                onChange={e => {
                  setForm({ ...form, first: e.target.value })
                }}
                placeholder='First Name'
                mb={3}
              />
            </Box>
            <Box
              sx={{
                width: ['full', '1/2'],
                px: 3
              }}>
              <Label
                sx={{ color: 'gray.6' }}
                htmlFor='last'>Last Name</Label>
              <Input
                name='last'
                type='text'
                id='last'
                value={form.last}
                onChange={e => {
                  setForm({ ...form, last: e.target.value })
                }}
                placeholder='Last Name'
                mb={3}
              />
            </Box>
          </Flex>
          <Flex
            sx={{
              flexWrap: 'wrap',
              mx: -3
            }}>
            <Box
              sx={{
                width: ['full', '1/2'],
                px: 3
              }}>
              <Label
                sx={{ color: 'gray.6' }}
                htmlFor='phone'>Phone</Label>
              <Input
                name='phone'
                type='tel'
                id='phone'
                value={form.phone}
                onChange={e => {
                  setForm({ ...form, phone: e.target.value })
                }}
                placeholder='Phone'
                mb={3}
              />

            </Box>
            <Box
              sx={{
                width: ['full', '1/2'],
                px: 3
              }}>
              <Label
                sx={{ color: 'gray.6' }}
                htmlFor='email'>Email</Label>
              <Input
                name='email'
                type='email'
                id='email'
                value={form.email}
                onChange={e => {
                  setForm({ ...form, email: e.target.value })
                }}
                placeholder='Email'
                mb={3}
              />
            </Box>
          </Flex>
        </Box>
        <Box
          sx={{
            px: 4,
            width: ['full', '1/2']
          }}>
          <Styled.h4
            sx={{
              color: 'gray.7',
              mb: 3
            }}>
            Referral Details
          </Styled.h4>
          <Flex
            sx={{
              flexWrap: 'wrap',
              mx: -3
            }}>
            <Box
              sx={{
                width: ['full', '1/2'],
                px: 3
              }}>
              <Label
                sx={{ color: 'gray.6' }}
                htmlFor='referralFirst'>Referral First Name</Label>
              <Input
                name='referralFirst'
                id='referralFirst'
                value={form.referralFirst}
                onChange={e => {
                  setForm({ ...form, referralFirst: e.target.value })
                }}
                placeholder='First Name'
                mb={3}
              />
            </Box>
            <Box
              sx={{
                width: ['full', '1/2'],
                px: 3
              }}>
              <Label
                sx={{ color: 'gray.6' }}
                htmlFor='referralLast'>Referral Last Name</Label>
              <Input
                name='referralLast'
                type='text'
                id='referralLast'
                value={form.referralLast}
                onChange={e => {
                  setForm({ ...form, referralLast: e.target.value })
                }}
                placeholder='Last Name'
                mb={3}
              />
            </Box>
          </Flex>
          <Flex
            sx={{
              flexWrap: 'wrap',
              mx: -3
            }}>
            <Box
              sx={{
                width: ['full', '1/2'],
                px: 3
              }}>
              <Label
                sx={{ color: 'gray.6' }}
                htmlFor='referralPhone'>Referral Phone</Label>
              <Input
                name='referralPhone'
                type='tel'
                id='referralPhone'
                value={form.referralPhone}
                onChange={e => {
                  setForm({ ...form, referralPhone: e.target.value })
                }}
                placeholder='Phone'
                mb={3}
              />

            </Box>
            <Box
              sx={{
                width: ['full', '1/2'],
                px: 3
              }}>
              <Label
                sx={{ color: 'gray.6' }}
                htmlFor='referralEmail'>Referral Email</Label>
              <Input
                name='referralEmail'
                type='email'
                id='referralEmail'
                value={form.referralEmail}
                onChange={e => {
                  setForm({ ...form, referralEmail: e.target.value })
                }}
                placeholder='Email'
                mb={3}
              />
            </Box>
          </Flex>
        </Box>
      </Flex>

      <Flex
        sx={{
          mx: -4,
          flexDirection: 'column'
        }}>
        <Box
          sx={{
            px: 4,
            width: 'full',
            mb: 4
          }}>
          <Label
            sx={{ color: 'gray.6' }}
            htmlFor='comment'>Comments</Label>
          <Textarea
            name='comment'
            id='comment'
            value={form.comment}
            onChange={e => {
              setForm({ ...form, comment: e.target.value })
            }}
            sx={{
              fontFamily: 'body'
            }}
            rows='6'
          />
          <small sx={{ color: 'gray.5' }}>Tell us more about your referral!</small>
        </Box>

        {success && (
          <Box
            sx={{
              width: 'full',
              px: 4
            }}>
            <Flex
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                p: 3,
                bg: 'green.2',
                borderStyle: 'solid',
                borderWidth: 4,
                borderColor: 'green.4',
                color: 'green.6',
                fontWeight: 'normal',
                mb: 4,
                width: 'full'
              }}>
              <span>Thank you, we received your referral!</span>
            </Flex>
          </Box>
        )}

        <Box
          sx={{
            px: 4,
            width: 'full',
            textAlign: 'right'
          }}>
          <Button
            variant='primary'>
            Get Started
          </Button>
        </Box>
      </Flex>
    </Box>
  )
}

export default ReferralForm